import { render, staticRenderFns } from "./Myclass.vue?vue&type=template&id=107f58d6&scoped=true"
import script from "./Myclass.vue?vue&type=script&lang=js"
export * from "./Myclass.vue?vue&type=script&lang=js"
import style0 from "./Myclass.vue?vue&type=style&index=0&id=107f58d6&prod&scoped=true&lang=css"
import style1 from "./Myclass.vue?vue&type=style&index=1&id=107f58d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "107f58d6",
  null
  
)

export default component.exports